import React from 'react';

import { Box, Button, Stack } from '@mui/material';

import Spinner from '~/components/Common/Spinner';

import { chunkArray } from '~/utils/chunkArray';

// AddableCheckboxGroup is a group of checkboxes to which new options can be
// added. It is merely presentational and appropriate handlers and values should
// be passed down from the field used by jsonschema-form
interface Props {
  options: Array<string>;
  selection: Array<string>;
  onChange: (value: string, checked: boolean) => void;
  onStartAddingAmenities: () => void;
  onSyncRoomAmenities?: () => void;
  isFlashOffer?: boolean;
  isGeneratingRoomAmenities?: boolean;
}

// IDEA: looping is not the most efficient solution. Maybe use Set or object
// if the number of options grow
function isChecked(selection: Array<string>, value: string) {
  for (let i = 0; i < selection.length; i++) {
    const option = selection[i];

    if (option === value) {
      return true;
    }
  }

  return false;
}

export default function AddableCheckboxGroup({
  options,
  selection,
  onChange,
  onStartAddingAmenities,
  onSyncRoomAmenities,
  isFlashOffer,
  isGeneratingRoomAmenities,
}: Props) {
  const countColumns = 4;
  const chunkSize = Math.ceil(options.length / countColumns);
  const chunks = chunkArray(options, chunkSize);

  return (
    <Box className="addable-checkbox-group">
      <Box display="grid" gap={2} gridTemplateColumns="repeat(4, 1fr)">
        {chunks.map((items, idx) => (
          <Box key={idx}>
            <ul className="option-list list-unstyled">
              {items.map((option) => {
                const optionId = option.toLowerCase().replace(/\s/, '-');

                return (
                  <li className="option-item" key={optionId}>
                    <label className="option">
                      <input
                        type="checkbox"
                        value={option}
                        checked={isChecked(selection, option)}
                        onChange={(e) => {
                          const val = e.target.value;
                          const checked = e.target.checked;

                          onChange(val, checked);
                        }}
                      />
                      {option}
                    </label>
                  </li>
                );
              })}
            </ul>
          </Box>
        ))}
      </Box>
      <Box display="flex" alignItems="center" justifyContent="flex-end" gap={2} mx={2}>
        <Stack direction="row" gap={2} alignItems="center">
          {onSyncRoomAmenities && isFlashOffer && (
            <Button
              variant="outlined"
              onClick={onSyncRoomAmenities}
              disabled={isGeneratingRoomAmenities}
              startIcon={isGeneratingRoomAmenities ? <Spinner size={16} /> : null}
            >
              {isGeneratingRoomAmenities ? 'Syncing...' : 'Sync Room Amenities'}
            </Button>
          )}
          <Button variant="text" onClick={onStartAddingAmenities}>
            Add
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
